import React, { FC, forwardRef, ReactNode, useMemo } from "react";
import { Box } from "@mui/material";
import { SxProps } from "@mui/material";
import { merge } from "lodash";

export interface SupportingPaneProps {
  open: boolean;
  sx?: SxProps;
  children: ReactNode;
  onToggleOpen?: (value: boolean) => void;
}

export const SupportingPane = forwardRef<HTMLElement, SupportingPaneProps>(
  (props, ref) => {
    const sx: SxProps = useMemo(() => {
      return merge(
        {
          flex: 1,
          minHeight: 0,
          minWidth: 0,
          display: props.open ? "flex" : undefined,
        },
        props.sx
      );
    }, [props.open, props.sx]);

    return (
      <Box ref={ref} className={"SupportingPane"} component={"aside"} sx={sx}>
        {props.open && props.children}
      </Box>
    );
  }
);

SupportingPane.displayName = "SupportingPane";
